import i18n from 'i18n-literally'

import * as yup from 'yup'

export const getRegisterGatewayValidationSchema = () => yup.object().shape({
  serialNumber: yup.string()
    .min(11, 'serial number must have 11 caracters.')
    .max(11, ' serial number must have 11 characters.')
    .required(i18n`The serial number is required.`),
  key: yup.string()
    .min(12, 'key number must have 12 characters.')
    .max(12, 'key number must have 12 characters.')
    .required(i18n`The key is required.`)
})

export const getRegisterGatewayInitialValues = () => ({
  serialNumber: undefined,
  key: undefined,
})
